import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { DxButtonModule, DxTextBoxModule, DxPopupModule, DxScrollViewModule } from 'devextreme-angular';
import { CtlGenKisiAramaComponent } from './ctl-gen-kisi-arama/ctl-gen-kisi-arama.component';
import { GenKisiService } from './ctl-gen-kisi.service';
import { CommonModule } from '@angular/common';
import {CtlSablonComponent} from '../ctl-sablon/ctl-sablon.component';
import { LabelMode } from 'devextreme/common';

import { UtilsService } from '../../../services/utils.service';
import { OrtakService } from '../../../services/ortak.service';
import { DkGlobalUserSettingsService } from '../../../services/dk-global-user-settings.service';
@Component({
  selector: 'dk-ctl-gen-kisi',
  templateUrl: './ctl-gen-kisi.component.html',
  styleUrls: ['./ctl-gen-kisi.component.scss'],
  standalone: true,
  imports: [
    DxTextBoxModule,
    DxButtonModule,
    CtlGenKisiAramaComponent,
    CommonModule,
    DxPopupModule,
    DxScrollViewModule,
    CtlSablonComponent,
  ],
  providers: [GenKisiService],
})
export class CtlGenKisiComponent implements OnInit {
  @ViewChild(CtlSablonComponent) ctlSablonComponent: CtlSablonComponent;
  @Input() labelText = "";
  @Input() isShowInfo = false;
  @Input() isShowViewBtn = false;
  @Input() labelMode:LabelMode = this.globalSettings.globalLabelMode;
  @Input() validationRulesMap!:any[];
  @Input() validationV2= false;
  @Input() exBirlesenEh= false;
  @Input() acceptZeroValue= false;
  public crudPopupVisible = false;
  public crudInfoPopoverVisible = false;
  public title!: string;
public isFirst = true;
  public control!: any;
  controlName = "GenKisi";
  @Input() isReadOnly = false;
  @Input() isBindCheck = false;
  public data: any;
  public dataAdres: any;
  public dataIletisim: any;
  @Input() code: any;
  @Input() columnName = "Kod"
  @Input() labelWidth: string;
  @Input() exIhaleKod: number;
  @Input() teklifKod: number;
  @Input() filterColumn: string;
  @Input() multipleDisplay = false;
  @Input() warningMessage: string | null = null;
  @Input() customQuery:string = "";
  @Input() tabIndex:number;
  @Output() viewButtonClicked: EventEmitter<any> = new EventEmitter();
  public searchPopupFirstCheck = 0;
  public filterColumnValue: any;
  public isPopupSelected = false;

  @Input() filterArray: any[] = [];

  /**
   * Açıkken: Kişi Kod ile bulunamayan 10-11 haneli sayısal değerler TCKN / Vergi No
   * olarak da aranır. Tek kayıt bulunursa doldurur, birden fazla bulursa arama
   * ekranını aynı filtreyle açar. Varsayılan kapalı - mevcut kullanımlar etkilenmez.
   */
  @Input() tcknVergiNoIleAra = false;
  public altAramaFilter: any = null;

  target:any;
  @Output() public dataResult: EventEmitter<any> = new EventEmitter();
  initialKisiKod: number;

  private lastRequestId = 0;

  constructor(private service: GenKisiService, private utilsService: UtilsService, private ortakService: OrtakService,private globalSettings:DkGlobalUserSettingsService) {}

  ngOnInit(): void {
    if (this.controlName) {
      this.getControl();
    }
    this.setParams();
  }
    ngOnChanges(changes: SimpleChanges) {
      if (changes['isReadOnly'] || changes['isBindCheck'] || changes['customQuery']) {
          this.service.setParams(this.isShowInfo,this.exBirlesenEh,this.exIhaleKod,this.teklifKod,this.isReadOnly,this.isBindCheck,this.customQuery);
        }
    }
  getControl(){
    this.ortakService.getControl(this.controlName)
    .subscribe((data) => {
      this.control = data?.controlMetadata;
             //this.service.getDlist(this.control?.dlistCode);
      this.service._gridControlsList.next(data?.controlMetadata.dlistMetadata)
      //if(this.labelText === "")this.labelText = this.control.controlDescription;
        if(data?.controlMetadata.dlistMetadata.baseEntity){
          if(this.labelText === "")this.labelText = this.control.controlDescription;
          // DKM-5109 Clara: eski hâli (code=0 falsy olduğu için acceptZeroValue açıkken 0 sicilin adı açılışta gelmiyordu)
          // if(this.code && this.control) this.getData(this.code,true)
          const sifirKod = this.acceptZeroValue && (this.code === 0 || this.code === '0');
          if((this.code || sifirKod) && this.control) this.getData(this.code,true)
if(this.isFirst) this.isFirst = false;;
        }
    });
  }

  setParams(){
    this.service.setParams(this.isShowInfo,this.exBirlesenEh,this.exIhaleKod,this.teklifKod,this.isReadOnly,this.isBindCheck,this.customQuery);
  }

  searchClick() {
    this.crudPopupVisible = true
  }

  clear() {
    this.title = '';
    this.code = '';
    this.data = null;
    this.dataAdres = null;
    this.dataIletisim = null;
    this.isPopupSelected = false
    this.filterColumnValue = undefined;
    this.altAramaFilter = null;
    this.initialKisiKod = null
    this.dataResult.emit(null);
  }

  showInfo(e:any){
    this.target = e.element;
    this.crudInfoPopoverVisible = true;
  }

  showInfoPopup(){
    this.crudInfoPopoverVisible = false;
  }

  handleValueChange(e: any) {
    if(this.isPopupSelected){
      this.isPopupSelected = false;
    }
    else{
    this.searchPopupFirstCheck = 2
    this.isPopupSelected = false
    const isZero = e === 0 || e === '0';
    const isEmpty = e === '' || e === null || e === undefined || (isZero && !this.acceptZeroValue);
    if (isEmpty) this.clear();
    else if(!this.isFirst && this.initialKisiKod !== e) {
      // Bayrak senkron okunuyor; async load() callback'ine birakilirsa araya giren
      // programatik bir degisiklik bayragi degistirebilir.
      this.getData(e, false, this.ctlSablonComponent?.isUserInput === true);
      this.initialKisiKod = e
    }
    this.isFirst = false;
    }
  }

  getData(code: any, isSetData?: boolean, kullaniciGirdisi = false) {
  if(this.columnName ==="VergiNo") this.data = this.service.getData(this.control,this.filterColumn,code,this.isShowInfo,this.exBirlesenEh,this.columnName,this.control.dlistMetadata.baseEntity,this.filterArray,isSetData);
    else this.data = this.service.getData(this.control,this.filterColumn,Number(code),this.isShowInfo,this.exBirlesenEh,this.columnName,this.control.dlistMetadata.baseEntity,this.filterArray,isSetData);

    const requestId = ++this.lastRequestId;
    this.data.load().done((result: any) => {
      if (requestId !== this.lastRequestId){
        return;
      }

      if (this.filterColumn?.length > 0) {

        if(result.length === 1){
          this.setSelectedRow(result[0]);
        }
        else if(result.length > 1){
          if(!this.isPopupSelected){
            if (this.filterColumn?.length > 0) {
              this.filterColumnValue = Number(code);
              if (this.searchPopupFirstCheck >= 2) this.searchClick();
              this.searchPopupFirstCheck = this.searchPopupFirstCheck + 1;
            } else {
              this.utilsService.showError('Bulunamadı');
              this.clear();
            }
          }
        } else if (!this.tcknVergiNoAra(code, kullaniciGirdisi)) {
          this.utilsService.showError('Bulunamadı');
          this.clear();
        }

      } else {

        if (result.length > 0) {
          this.setSelectedRow(result[0]);
        } else if (this.code != null && this.code !== '') {
          if (!this.tcknVergiNoAra(code, kullaniciGirdisi)) {
            this.utilsService.showError('Bulunamadı');
            this.clear();
          }
        }
      }



    });

  }

  /** Bulunan GenKisi satırını kontrole yerleştirir ve dışarı bildirir. */
  private setSelectedRow(row: any) {
    if (this.isShowInfo) {
      this.dataAdres = row.GenKisiAdres[0];
      this.dataIletisim = row.GenKisiIletisims[0];
    }
    this.title = '';
    if (row.Ad) this.title = this.title + row.Ad + ' ';
    if (row.Soyad) this.title = this.title + row.Soyad + ' ';
    if (row.Unvani) this.title = this.title + row.Unvani;
    this.code = row[this.columnName];
    this.dataResult.emit(row);
  }

  /**
   * Kod ile bulunamayan değeri TCKN / Vergi No olarak arar.
   * Aramayı başlattıysa true döner - bu durumda çağıran taraf 'Bulunamadı' göstermemeli,
   * sonucu bu metot değerlendirir.
   */
  private tcknVergiNoAra(code: any, kullaniciGirdisi: boolean): boolean {
    // Sadece klavyeden girilen degerlerde calisir. [code] binding'i, arama ekranindan
    // secim sonrasi kutuya yazilan Kod ve clear() programatik oldugu icin tetiklemez.
    if (!kullaniciGirdisi) return false;
    if (!this.tcknVergiNoIleAra) return false;
    if (this.columnName !== 'Kod') return false;
    // Sadece TCKN (11) / Vergi No (10) uzunluğundaki sayısal değerler için ikinci istek at.
    if (!/^\d{10,11}$/.test(String(code ?? ''))) return false;

    const requestId = ++this.lastRequestId;
    const dataSource = this.service.getDataByTcknVergiNo(
      this.control,
      code,
      this.exBirlesenEh,
      this.control.dlistMetadata.baseEntity,
      this.filterArray
    );

    dataSource.load().done((result: any) => {
      if (requestId !== this.lastRequestId) return;

      if (result.length === 1) {
        this.setSelectedRow(result[0]);
        // code programatik değişti; handleValueChange'in tekrar sorgu atmasını engelle.
        this.initialKisiKod = result[0][this.columnName];
      } else if (result.length > 1) {
        this.altAramaFilter = this.service.tcknVergiNoFilter(code);
        this.searchClick();
      } else {
        this.utilsService.showError('Bulunamadı');
        this.clear();
      }
    });

    return true;
  }

  closePopupAfter(result: any, sablonCmp: CtlSablonComponent) {
    if (result?.data) {
      if(this.filterColumn?.length > 0){
        if(Number(result.data[this.filterColumn]) > 0){
          if(this.initialKisiKod !== result.data[this.columnName]) this.code = result.data[this.columnName];
          if(this.isShowInfo){
            this.dataAdres = result.data.GenKisiAdres[0]
            this.dataIletisim = result.data.GenKisiIletisims[0]
          }
          this.title = '';
          if (result.data.Ad) this.title = this.title + result.data.Ad + ' ';
          if (result.data.Soyad) this.title = this.title + result.data.Soyad + ' ';
          if (result.data.Unvani) this.title = this.title + result.data.Unvani;
          this.dataResult.emit(this.data);
          this.isPopupSelected = true;
        }
      }
      else{
        if(this.initialKisiKod !== result.data[this.columnName]) this.code = result.data[this.columnName];
        this.dataResult.emit(result.data);
          setTimeout(() => {
            this.data = result.data;

          if(this.isShowInfo){
            this.dataAdres = result.data.GenKisiAdres[0]
            this.dataIletisim = result.data.GenKisiIletisims[0]
          }
          }, 100);

      }
      }
    this.crudPopupVisible = false;
    this.filterColumnValue = undefined;
    this.altAramaFilter = null;
    setTimeout(() => {
      sablonCmp.focusInput();
    });
  }

  viewButtonlick($event: any) {
    this.viewButtonClicked.emit($event);
  }
}
